"use strict";

angular.module("core").controller("TreeSelectorController", function(Language, $scope, $attrs, tree_options, close) {
    Language.initializeScope($scope, "language");
    this.tree = $attrs.tree;
    $scope.selected = $attrs.selected || {};
    $scope.title = $attrs.title;
    $scope.readOnly = $attrs.readOnly;
    $scope.expanded = $attrs.expanded || ((this.tree.length && $attrs.autoExpandFirst)?[this.tree[0]]:[]);
    $scope.validate = $attrs.validate || function(selected) {
        return selected !== undefined;
    };

    $scope.options = {
        dirSelectable: false,
        allowDeselect: false,
        equality: function(a, b) {
            return a && b
                && a.hasOwnProperty("id") && b.hasOwnProperty("id")
                && a.id == b.id;
        },
        injectClasses: {
            iExpanded: "fa fa-minus-square",
            iCollapsed: "fa fa-plus-square",
            iLeaf: "fa fa-tag"
        }
    };
    _.extend($scope.options, tree_options);

    $scope.onSelect = function(node, expanded, path) {
        var selectedPath = path();
        selectedPath.splice(0, 1);
        node.path = selectedPath.reverse();
        $scope.onToggle(node, expanded);
    }

    $scope.onToggle = function(node, expanded) {
        var index = this.expanded.indexOf(node);
        if (index > -1) {
            $scope.expanded.splice(index, 1);
        }
        if (expanded) {
            $scope.expanded.push(node);
        }
    };

    $scope.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    $scope.cancel = function() {
        // the initial value
        $scope.close($attrs.selected);
    };

    $scope.select = function() {
        // remember the path
        $scope.close($scope.selected);
    };

    $scope.isEmpty = function(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/mptt-selector/mptt-selector.modal.js
// module id = 549
// module chunks = 0